module.exports = [
  {
    title: 'Наименование',
    key: 'name'
  },
  {
    title: 'Тип',
    key: 'type'
  },
  {
    title: 'ID',
    key: 'id'
  }
]
